import React from 'react';
import music from '../../images/music.jpg';

function Hobbies() {
  return (
    <div id="hobbiesSection" className="hobbies">
      <h1 className="hobbies-text">Hobbies</h1>
      <div className="hobbies-div">
        <div style={{ flex: '1' }}>
          <img alt="music" src={music} className="hobbies-img" />
        </div>
        <div className="hobbies-content-div">
          <div className="hobbies-content">I'm an ardent cricket fan - I love watching and playing the game.</div>
          <div className="hobbies-content">I enjoy listening to music(who doesn't?) and having an occasional read.</div>
          <div className="hobbies-content">And, of course, I love to code.</div>
        </div>
      </div>
    </div>
  )
}

export default Hobbies;